<div *ngIf="isLoading == true; else hasLoaded">
  <app-spinner></app-spinner>
</div>
<ng-template #hasLoaded>
  <div>
    <div class="fx-xs-column fx-row fx-align-space-between-center">
      <div class="fx-row fx-align-start-center fx-flex-30" id="header__wrapper">
        <app-count-header [title]="inventory$.invBatchName"></app-count-header>
      </div>
      <h2 class="text-center w-100">Excel</h2>
      <div class="flex fx-align-end-center fx-flex-30 invButton__wrapper">
        <div class="fx-layout-lt-md-column fx-row fx-gap-30px">
          <app-select-report></app-select-report>
          <button mat-raised-button color="primary" (click)="_inventory.onInventoryExcel(headers, inventory$, dataSource)">
            {{ "generateExcel" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-12 table-responsive">
    <table matTableExporter #exporter="matTableExporter" mat-table [dataSource]="dataSource" matSort
      (matSortChange)="sortData($event)" width="100%">

      <ng-container matColumnDef="prdCode">
        <mat-header-cell *matHeaderCellDef mat-sort-header>SKU</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <span class="mobile-label">SKU</span>
          <span [innerHTML]="element.prdCode"></span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="prdNameEn">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="text-left"> {{ "productDescription" | translate }} </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <span class="mobile-label">{{ "products.table.prdNameEn" | translate }}</span>
          <span [innerHTML]="element.prdNameEn"></span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="barcode">
        <mat-header-cell *matHeaderCellDef mat-sort-header> {{ "barcode" | translate }} </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <span class="mobile-label">{{ "barcode" | translate }}</span>
          <span [innerHTML]="element.barcodeData"></span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="count">
        <mat-header-cell *matHeaderCellDef mat-sort-header> {{ "count" | translate }} </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <span class="mobile-label">{{ "count" | translate }}</span>
          <span>{{(element.invitmCount).toFixed(2) }}</span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="prdPackageUOM">
        <mat-header-cell *matHeaderCellDef mat-sort-header> {{ "countType" | translate }} </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <span class="mobile-label">{{ "countType" | translate }}</span>
          <span>{{ element?.count.pcmDesc }}</span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="prdCost">
        <mat-header-cell *matHeaderCellDef mat-sort-header> {{ "costPerUnit" | translate }} </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <span class="mobile-label">{{ "costPerUnit" | translate }}</span>
          <span>{{ element?.count.pcmCost | currency }}</span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="prdRetail">
        <mat-header-cell *matHeaderCellDef mat-sort-header> {{ "retailPrice" | translate }} </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <span class="mobile-label">{{ "retailPrice" | translate }}</span>
          <span>{{ element.count.pcmRetail | currency }}</span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="totalCost">
        <mat-header-cell *matHeaderCellDef mat-sort-header> {{ "totalCost" | translate }} </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <span class="mobile-label">{{ "totalPrice" | translate }}</span>
          <span>{{ element.count.pcmCost * element.invitmCount | currency }}</span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="totalRetail">
        <mat-header-cell *matHeaderCellDef mat-sort-header> {{ "totalRetail" | translate }} </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <span class="mobile-label">{{ "totalRetail" | translate }}</span>
          <span>{{ element.invitmCount * element.count.pcmRetail | currency }}</span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="minQty">
        <mat-header-cell *matHeaderCellDef mat-sort-header>MSL</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <span class="mobile-label">MSL</span>
          <span>{{element.count?.pcmMinQty1}}</span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="reorder">
        <mat-header-cell *matHeaderCellDef mat-sort-header> {{ "reOrder" | translate }} </mat-header-cell>
        <mat-cell *matCellDef="let element" class="fx-row fx-align-none-center">
          <span class="mobile-label">{{ "reOrder" | translate }}</span>
          <span>{{ reorder(element.count?.pcmMinQty, element.invitmCount) }}</span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="category">
        <mat-header-cell *matHeaderCellDef> {{ "category" | translate }} </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <span class="mobile-label">{{ "category" | translate }}</span>
          <span>{{element?.prdCatNameEn}}</span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="areas">
        <mat-header-cell *matHeaderCellDef class="fx-row fx-align-end-center"> {{ "area" | translate }} </mat-header-cell>
        <mat-cell *matCellDef="let element" class="fx-align-end-center">
          <span class="mobile-label">{{ "area" | translate }}</span>
          <span>{{element.areas[0]?.prdAreaNameEn}}</span>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;" appInventoryRow [prdID]="row.prdID" [invitmID]="row.invitmID"></mat-row>
    </table>
  </div>
</ng-template>